import request from "../plugin/axios/index.js";
import Global from "@/Global.js";
export function businessGet(url, val) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
    },
    method: "get",
    params: val,
  });
}

export function businessGet2(url, val) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
    },
    method: "get",
    responseType: 'arraybuffer',
    params: val,
  });
}

export function businessGet3(url) {
  return new Promise((resolve) => {
    let token = localStorage.getItem(Global.GlobalLocalToken);
    fetch(process.env.VUE_APP_API_URL + url, {
      method: 'GET', // 或者你需要的其他HTTP方法
      headers: {
        'Authorization': token,
        // 如果需要，可以在这里添加其他头部信息
      }
    })
      .then(response => response.arrayBuffer()) // 将响应转换为 ArrayBuffer
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        console.error('Error fetching the model:', error);
      });
  });

}

export function businessPost(url, val) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
    },
    method: "post",
    data: val,
  });
}

export function businessPost2(url, val) {
  return new Promise((resolve) => {
    let token = localStorage.getItem(Global.GlobalLocalToken);
    fetch(process.env.VUE_APP_API_URL + url, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(val)
    }).then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.arrayBuffer();
    }).then(data => {
      resolve(data);
    }).catch(error => {
      console.error('Error fetching the model:', error);
    });
  });
}

export function businessPostNoToken(url, val) {
  return request({
    url: process.env.VUE_APP_API_URL + url,
    method: "post",
    data: val,
  });
}
export function businessDel(url) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
    },
    method: "delete",
  });
}
export function businessPut(url, val) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
    },
    method: "put",
    data: val,
  });
}

export function businessForm(url, formData) {
  let token = localStorage.getItem(Global.GlobalLocalToken);
  return request({
    url: process.env.VUE_APP_API_URL + url,
    headers: {
      Authorization: token,
      "Content-Type": "multipart/form-data",
    },
    method: "post",
    data: formData,
  });
}
